module.exports = __webpack_public_path__ + "img/loader.ec234eee.svg";